import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"persistent":""},model:{value:(_vm.openModal),callback:function ($$v) {_vm.openModal=$$v},expression:"openModal"}},[_c(VCard,[_c(VCardText,[_c('iframe',{staticStyle:{"width":"100%","height":"70vh"},attrs:{"src":_vm.path}})]),_c(VCardActions,[_c(VSpacer),_c(VBtn,{staticClass:"red",attrs:{"dark":""},on:{"click":_vm.closeModal}},[_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-close")]),_vm._v("\n        Cerrar\n      ")],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }